import axios from "axios";
import querystring from "querystring";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
const token = localStorage.getItem('user-token');
const user = localStorage.getItem('user-id');
if (token && user) {
    axios.defaults.headers.common['X-Authorization'] = 'Bearer ' + token;
    axios.defaults.headers.common['X-User'] = user;
}

/*const config = {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
};*/

const getters = {
    ORGFILTERS: state => {
        //console.log(state.bddsplanfiletrs);
        return state.orgfiletrs;
    },
    ORG: state => {
        //console.log(state.bddsplanfiletrs);
        return state.org;
    },
    HOUSE: state => {
        //console.log(state.bddsplanfiletrs);
        return state.house;
    },
};
const mutations = {
    SET_ORGFILTERS: (state, payload) => {
        state.orgfiletrs = payload;
    },
    SET_ORG: (state, payload) => {
        state.org = payload;
    },
    SET_HOUSE: (state, payload) => {
        state.house = payload;
    },
};
const actions = {
    GET_ORGFILTERS: async (context, payload) => {
        const req = querystring.stringify(payload);
        let {data} = await axios.get('/budget-api/settings/filters?' + req);
        context.commit('SET_ORGFILTERS', data);
        return data;
    },
    GET_ORG_LIST: async (context, payload) => {
        const req = querystring.stringify(payload);
        let {data} = await axios.get('/budget-api/settings/org?' + req);
        context.commit('SET_ORG', data);
        return data;
    },
    GET_HOUSE_LIST: async (context, payload) => {
        const req = querystring.stringify(payload);
        let {data} = await axios.get('/budget-api/settings/house?' + req);
        context.commit('SET_HOUSE', data);
        return data;
    },

};

export default {
    state: () => ({
        orgfiletrs: null,
        org: null,
        house: null,
    }),
    mutations,
    actions,
    getters
};
